import React from "react";
import { useCreateMailTemplateRequest } from "../../hooks/useCreateMailTemplateRequest";
import { MailTemplateForm } from "./MailTemplateForm";
import { type MailTemplateFormData } from "../../types/schemas";

export const MailTemplateNew: React.FC = () => {
  const createMailTemplate = useCreateMailTemplateRequest();

  const handleSubmit = (data: MailTemplateFormData): void => {
    createMailTemplate(data);
  };

  return <MailTemplateForm onSubmit={handleSubmit} />;
};
